module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/72005810d7b58a20712589fa026ca2c6.png";